import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";

// Store
import { store, persistor } from "src/store";
import { initFaro } from "./services/logger";
import "./services/posthog";

// Components
import App from "src/app";

// Styles
import "src/sass/main.css";
import { FaroErrorBoundary } from "@grafana/faro-react";

const oldlog = console.log;
window.console.log = function () {
  oldlog.apply(null, [...arguments]);
};

initFaro();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <FaroErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
        <ToastContainer />
      </PersistGate>
    </Provider>
  </FaroErrorBoundary>,
);
